module.exports = __webpack_public_path__ + "static/media/Icon.2e42e08f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Icon.png
// module id = 73
// module chunks = 0